function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "ymca-icon-logo"
}, "YMCA Icon Logo");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Dsigns"
}, React.createElement("g", {
  id: "Bitmap"
}, React.createElement("path", {
  d: "M12.48,36.4c-.68-.24-.78-.38-.78-1.13V21.76a4.07,4.07,0,0,0-.59-2.17Q5.64,10.28.18.93C.05.71-.11.46.1.25A1,1,0,0,1,.72,0C3.47,0,6.22,0,9,0A2,2,0,0,1,10.9,1.1q3.69,6.38,7.39,12.75l3.44,5.93a3.39,3.39,0,0,1,.49,1.78q0,6.86,0,13.7a1,1,0,0,1-.74,1.14Z"
}), React.createElement("path", {
  d: "M23.59,0H33c.85,0,1.11.45.69,1.17L24.24,17.54c-.41.7-.92.71-1.34,0L13.42,1.12C13,.46,13.3,0,14.06,0Zm0,4H20.43c-.55,0-.61.1-.34.58l3.17,5.49c.24.42.39.41.64,0l3.18-5.52c.23-.4.16-.53-.31-.53Z"
})));

var SvgYmcaIconLogo = function SvgYmcaIconLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "aria-labelledby": "ymca-icon-logo-title",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 33.89 36.4",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "ymca-icon-logo"
  }, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgYmcaIconLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ymca-icon-logo.7519581a.svg";
export { ForwardRef as ReactComponent };